import Header from "../components/Header"
import RestaurantDetailsForm from "../components/RestaurantDetailsForm" // Assure-toi que ce fichier existe
import Footer from "../components/Footer"

function Detail() {
  return (
    <>
      <Header />
      <RestaurantDetailsForm />
      <Footer />
    </>
  )
}

export default Detail;
